import util from 'util';
import { gql } from '@apollo/client';
import xml2js from 'xml2js';
import * as commonUtil from './util';

const { promisify } = util;
const parseString = promisify(xml2js.parseString);
const { formatGraphQLError } = commonUtil;

const create = client => {
  const signedUrl = async type => {
    const { data, error: err } = await client.mutate({
      mutation: gql`
        mutation uploadAssetUrl($input: UploadAssetUrlInput!) {
          uploadAssetUrl(input: $input) {
            data
          }
        }
      `,
      variables: {
        input: {
          type,
        },
      },
    });

    if (err) {
      throw formatGraphQLError(err);
    }
    return data.uploadAssetUrl.data;
  };

  const post = async (url, body) => {
    const res = await fetch(url, {
      method: 'POST',
      body,
    });
    const { status, statusText } = res;

    if (![200, 201, 204].includes(status)) {
      const xml = await res.text();
      const error = await parseString(xml);
      throw Object.assign(
        new Error(statusText),
        {
          status,
        },
        error
      );
    }
  };

  const signedUpload = async (url, fields) => {
    const body = Object.keys(fields).reduce((formData, key) => {
      formData.append(key, fields[key]);
      return formData;
    }, new FormData());

    await post(url, body);

    return `${url}/${fields.key}`;
  };

  const upload = async file => {
    const { url, fields } = await signedUrl(file.type);
    const { type, name } = file;

    return signedUpload(url, {
      ...fields,
      'Content-Type': type,
      'Content-Disposition': `attachment; filename=${name}`,
      file,
    });
  };

  return { upload };
};

export { create };
